import React, { Fragment, useState, useEffect, useRef } from "react";
import { MenuItem, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import { currentRouteSet } from "../../actions/actions";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {
  pathSpliter,
  checkAuthBranchWare,
  dateTimeFormat,
  checkIntNum,
  currentDateTime,
  getDateTimeFromISODT,
} from "../../lib/functions";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { APP_URL, API_URL } from "../../config";
import { useHistory } from "react-router-dom";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import LoadingButton from "../commons/LoadingButton";
import EditIcon from "@material-ui/icons/Edit";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";

import DateFnsUtils from "@date-io/date-fns"; // choose your lib

import "./components/sale.css";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import {
  DatePicker,
  TimePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import swal from "sweetalert";
import { CardContent } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import commaNumber from "comma-number";
import { use } from "react";
import Pagination from "@material-ui/lab/Pagination";

let format = commaNumber.bindWith(",", ".");

const SalesEntry = ({ location, currentRoute, currentRouteSet, authInfo }) => {
  const classes = useStyles();
  const [selectedDate, handleDateChangeSet] = useState(currentDateTime);

  const history = useHistory();

  // States start
  // Initialize cart from localStorage
  let [cart, cartSet] = useState(() => {
    const savedCart = localStorage.getItem('salesCart');
    return savedCart ? JSON.parse(savedCart) : [];
  });

  let [storageCart, storageCartSet] = useState(() => {
    const savedStorageCart = localStorage.getItem('salesStorageCart');
    return savedStorageCart ? JSON.parse(savedStorageCart) : [];
  });

  let [employees, employeesSet] = useState([]);
  let [customers, customersSet] = useState([]);
  let [floors, floorsSet] = useState([]);
  let [racks, racksSet] = useState([]);
  let [contactPersons, contactPersonsSet] = useState([]);
  let [products, productsSet] = useState([]);
  let [allProducts, allProductsSet] = useState([]);

  const [floor, setFloor] = useState({ prod_floor_id: 0, prod_floor_name: "" });
  const [rack, setRack] = useState({ prod_rack_id: 0, prod_rack_name: "" });

  let [selectedEmployee, selectedEmployeeSet] = useState(null);
  let [selectedCustomer, selectedCustomerSet] = useState(null);
  let [selectedContactPerson, selectedContactPersonSet] = useState(null);
  let [selectedFloor, selectedFloorSet] = useState(1);
  let [selectedQuantity, selectedQuantitySet] = useState(null);
  let [selectedRack, selectedRackSet] = useState(null);
  let [selectedProduct, selectedProductSet] = useState(null);
  let [selectedId, selectedIdSet] = useState(null);

  let [saveAction, saveActionSet] = useState(false);

  let [customerPayAccs, customerPayAccsSet] = useState([]);
  let [customer_type, customer_type_set] = useState("retail");

  let [selectedCustomerPayMethod, selectedCustomerPayMethodSet] = useState(
    { pay_method_id: "cash", pay_method: "Cash" },
    { pay_method_id: "bank", pay_method: "Bank" }
  );
  let [selectedCustomerPayAcc, selectedCustomerPayAccSet] = useState(null);

  let [sale_invoice, sale_invoice_set] = useState("");
  let [po_id, po_id_set] = useState("");
  let [sale_emp_id, sale_emp_id_set] = useState(0);

  let [sale_created_isodt, sale_created_isodt_set] = useState("");

  let [customer_name, customer_name_set] = useState("");
  let [customer_mobile_no, customer_mobile_no_set] = useState("");
  let [customer_address, customer_address_set] = useState("");

  let [product_rate, product_rate_set] = useState(0);
  let [product_brand, product_brand_set] = useState("");
  let [product_floor, product_floor_set] = useState("");
  let [product_rack, product_rack_set] = useState("");
  let [product_color, product_color_set] = useState("");
  let [product_qty, product_qty_set] = useState("");
  let [product_total, product_total_set] = useState(0);

  let [product_stock_status, product_stock_status_set] = useState("stock status");
  let [product_stock_qty, product_stock_qty_set] = useState("stock qty");
  let [product_unit, product_unit_set] = useState("unit");
  let [product_purchase_rate, product_purchase_rate_set] =
    useState("purchase rate");

  let [general_customer, general_customer_set] = useState(false);

  let [note, note_set] = useState("");
  let [sub_total, sub_total_set] = useState(0);
  let [previous_due, previous_due_set] = useState(0);
  let [vat, vat_set] = useState(0);
  let [ait, ait_set] = useState(0);
  let [vat_percent, vat_percent_set] = useState(0);
  let [ait_percent, ait_percent_set] = useState(0);
  let [discount, discount_set] = useState(0);
  let [discount_percent, discount_percent_set] = useState(0);
  let [total_amount, total_amount_set] = useState(0);
  let [paid, paid_set] = useState(0);
  let [due, due_set] = useState(0);
  let [transport_cost, transport_cost_set] = useState(0);
  let [saleAction, saleActionSet] = useState("create");
  let [saleId, saleIdSet] = useState(0);
  const [selectedLocation, setSelectedLocation] = useState("");
  let [customer_credit_limit, customer_credit_limit_set] = useState(0);
  let customerPayMethods = [
    { pay_method_id: "cash", pay_method: "cash" },
    { pay_method_id: "bank", pay_method: "bank" },
  ];
  const [resetKey, setResetKey] = useState(0);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(25); // 6x6 grid

  // State End
  const [locations, setLocations] = useState(
    {
      prod_floor_name: "",
      prod_rack_name: "",
    } || []
  );
  const [floorData, setFloorData] = useState([]);

  // Calculation Modes
  const [vatMode, vatModeSet] = useState("percent");
  const [aitMode, aitModeSet] = useState("percent");
  const [discountMode, discountModeSet] = useState("percent");

  // Helpers
  const num = (v) => {
    let n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  };

  const round2 = (x) => {
    return Math.round(x * 100) / 100;
  };

  const stopEnter = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  // Persist cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('salesCart', JSON.stringify(cart));
    localStorage.setItem('salesStorageCart', JSON.stringify(storageCart));
  }, [cart, storageCart]);

  // Cleanup localStorage on component unmount
  useEffect(() => {
    return () => {
      // Only clear if sale wasn't completed
      if (!saveAction) {
        localStorage.removeItem('salesCart');
        localStorage.removeItem('salesStorageCart');
      }
    };
  }, [saveAction]);

  useEffect(() => {
    selectedCustomerSet(null);
    customer_name_set("");
    customer_address_set("");
    customer_mobile_no_set("");
    selectedProductSet(null);
    product_rate_set("");
    product_brand_set("");
    product_color_set("");
    if (customer_type == "retail") {
      getCustomers("retail");
    }
    if (customer_type == "wholesale") {
      getCustomers("wholesale");
    }

    let prods = products.map((prod) => {
      if (customer_type == "wholesale") {
        prod.prod_rate = prod.prod_whole_sale_rate;
      }
      if (customer_type == "retail") {
        prod.prod_rate = prod.prod_sale_rate;
      }
      return prod;
    });

    productsSet(prods);
  }, [customer_type]);

  useEffect(() => {
    currentRouteSet(pathSpliter(location.pathname, 1));
    getInvoice();
    getEmployees();
    getProducts();
    getTranAccs();

    if (pathSpliter(location.pathname, 3) != undefined) {
      saleActionSet("update");
      saleIdSet(parseFloat(pathSpliter(location.pathname, 3)));
      getSales();
    }
  }, []);

  const getTranAccs = async () => {
    await axios
      .post(
        `${API_URL}/api/get-bank-accounts`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        customerPayAccsSet(res.data.message);
      });
  };

  let getSales = async () => {
    await axios
      .post(
        `${API_URL}/api/get-sales-with-details`,
        {
          reqPayload: { saleId: parseFloat(pathSpliter(location.pathname, 3)) },
        },
        { headers: { "auth-token": authInfo.token } }
      )
      .then(async (res) => {
        let sale = res.data.message[0];
        let cart = res.data.message[0].details;

        await axios
          .post(
            `${API_URL}/api/get-customer-due`,
            { customerId: sale.customer_id },
            { headers: { "auth-token": authInfo.token } }
          )
          .then((res) => {
            if (res.data.length == 0) {
              previous_due_set(0);
              return false;
            }
            previous_due_set(res.data[0].dueAmount);
          });

        sale_invoice_set(sale.sale_invoice);
        selectedEmployeeSet({
          employee_id: sale.sale_emp_id,
          employee_name: sale.employee_name,
        });
        handleDateChangeSet(sale.sale_created_isodt);
        selectedCustomerSet({
          customer_name: sale.customer_name,
          display_text: sale.customer_name,
          customer_id: sale.customer_id,
        });
        customer_name_set(sale.customer_name);
        customer_mobile_no_set(sale.customer_mobile_no);
        customer_address_set(sale.customer_address);
        customer_credit_limit_set(sale.customer_credit_limit);

        discount_set(sale.sale_discount_amount);
        discount_percent_set(sale.sale_discount_percent);
        vat_set(sale.sale_vat_amount);
        vat_percent_set(sale.sale_vat_percent);
        ait_set(sale.sale_ait_amount);
        ait_percent_set(sale.sale_ait_percent);
        total_amount_set(sale.sale_total_amount);
        paid_set(sale.sale_paid_amount);
        due_set(sale.sale_due_amount);

        let newCart = cart.map((ele) => {
          let product = {
            prod_id: ele.sale_prod_id,
            prod_name: ele.prod_name,
            prod_sale_rate: ele.sale_rate,
            prod_qty: ele.sale_qty,
            prod_purchase_rate: ele.sale_prod_purchase_rate,
            prod_total: ele.sale_prod_total,
          };
          return product;
        });
        cartSet(newCart);

        selectedCustomerPayMethodSet({
          pay_method_id: sale.sale_pay_method,
          pay_method: sale.sale_pay_method,
        });
        selectedCustomerPayAccSet({
          bank_display_name: sale.bank_display_name,
          bank_acc_id: sale.sale_bank_id,
        });
      });
  };

  // --- Calculators ---

  useEffect(() => {
    let subTotal = cart.reduce((prev, curr) => {
      return prev + num(curr.prod_total);
    }, 0);
    sub_total_set(round2(subTotal));
  }, [cart]);

  // Calculate Discount
  useEffect(() => {
    if (discountMode === "percent") {
      const discountAmount = (num(sub_total) * num(discount_percent)) / 100;
      discount_set(round2(discountAmount));
    } else {
      const discountPercent =
        sub_total > 0 ? (num(discount) * 100) / num(sub_total) : 0;
      discount_percent_set(round2(discountPercent));
    }
  }, [sub_total, discount_percent, discount, discountMode]);

  // Calculate VAT (on Discounted Amount)
  useEffect(() => {
    const afterDiscount = num(sub_total) - num(discount);
    if (vatMode === "percent") {
      vat_set(round2((afterDiscount * num(vat_percent)) / 100));
    } else {
      vat_percent_set(
        afterDiscount > 0 ? round2((num(vat) * 100) / afterDiscount) : 0
      );
    }
  }, [sub_total, discount, vat_percent, vat, vatMode]);

  // Calculate AIT (on Discounted Amount)
  useEffect(() => {
    const afterDiscount = num(sub_total) - num(discount);
    if (aitMode === "percent") {
      ait_set(round2((afterDiscount * num(ait_percent)) / 100));
    } else {
      ait_percent_set(
        afterDiscount > 0 ? round2((num(ait) * 100) / afterDiscount) : 0
      );
    }
  }, [sub_total, discount, ait_percent, ait, aitMode]);

  // Calculate Total
  useEffect(() => {
    const afterDiscount = num(sub_total) - num(discount);
    const total = afterDiscount + num(vat) + num(ait) + num(transport_cost);
    total_amount_set(round2(total));

    if (general_customer) {
      paid_set(round2(total));
      due_set(0);
    } else {
      due_set(round2(total - num(paid)));
    }
  }, [sub_total, discount, vat, ait, transport_cost, paid, general_customer]);


  // Handlers
  const handleDiscountInput = (e) => {
    const { name, value } = e.target;
    if (name === "discount_percent") {
      discount_percent_set(value);
      discountModeSet("percent");
    } else {
      discount_set(value);
      discountModeSet("amount");
    }
  };

  const handleVatInput = (e) => {
    const { name, value } = e.target;
    if (name === "vat_percent") {
      vat_percent_set(value);
      vatModeSet("percent");
    } else {
      vat_set(value);
      vatModeSet("amount");
    }
  };

  const handleAitInput = (e) => {
    const { name, value } = e.target;
    if (name === "ait_percent") {
      ait_percent_set(value);
      aitModeSet("percent");
    } else {
      ait_set(value);
      aitModeSet("amount");
    }
  };

  let employeeRef = useRef(null);
  let dateRef = useRef(null);
  let customerRef = useRef(null);
  let productRef = useRef(null);
  let rateRef = useRef(null);
  let brandRef = useRef(null);
  let countryRef = useRef(null);
  let floorRef = useRef(null);
  let rackRef = useRef(null);
  let qtyRef = useRef(null);
  let addToCartRef = useRef(null);
  let vatRef = useRef(null);
  let vatPercentRef = useRef(null);
  let aitRef = useRef(null);
  let aitPercentRef = useRef(null);
  let discountRef = useRef(null);
  let discountPercentRef = useRef(null);
  let transportRef = useRef(null);
  let paidRef = useRef(null);
  let dueRef = useRef(null);
  let saleRef = useRef(null);
  let savingRef = useRef(false);

  const fetchFloors = async () => {
    if (selectedProduct?.prod_id) {
      try {
        const response = await axios.post(
          `${API_URL}/api/get-product-floors`,
          { productId: selectedProduct.prod_id },
          { headers: { "auth-token": authInfo.token } }
        );

        if (response.data && !response.data.error) {
          floorsSet(response.data.data);
        } else {
          console.error("API returned an error:", response.data.message);
          setLocations([]);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        setLocations([]);
      }
    } else {
      setLocations([]);
    }
  };

  const fetchRacks = async () => {
    if (selectedProduct?.prod_id && selectedFloor?.prod_floor_id) {
      try {
        const response = await axios.post(
          `${API_URL}/api/get-product-racks`,
          {
            productId: selectedProduct.prod_id,
            floorId: selectedFloor.prod_floor_id,
          },
          { headers: { "auth-token": authInfo.token } }
        );

        if (response.data && !response.data.error) {
          racksSet(response.data.data);
        } else {
          console.error("API returned an error:", response.data.message);
          setLocations([]);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        setLocations([]);
      }
    } else {
      setLocations([]);
    }
  };

  const fetchProductQuantity = async () => {
    if (
      selectedProduct?.prod_id &&
      selectedFloor?.prod_floor_id &&
      selectedRack?.prod_rack_id
    ) {
      try {
        const response = await axios.post(
          `${API_URL}/api/get-product-quantity`,
          {
            productId: selectedProduct.prod_id,
            floorId: selectedFloor.prod_floor_id,
            rackId: selectedRack.prod_rack_id,
          },
          { headers: { "auth-token": authInfo.token } }
        );

        if (response.data && !response.data.error) {
          selectedQuantitySet(response.data.data[0].prod_qty);
        } else {
          console.error("API returned an error:", response.data.message);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    }
  };

  useEffect(() => {
    product_total_set(product_rate * product_qty);
  }, [product_rate, product_qty]);

  useEffect(() => {
    if (selectedProduct != null) {
      axios
        .post(
          `${API_URL}/api/get-product-current-stock`,
          { product_id: selectedProduct.prod_id },
          { headers: { "auth-token": authInfo.token } }
        )
        .then((res) => {
          product_stock_qty_set(res.data.message);
        });
    } else {
      product_stock_qty_set("Stock Qty");
    }
  }, [selectedProduct]);

  let getInvoice = async () => {
    await axios
      .get(`${API_URL}/api/get-sales-invoice`, {
        headers: { "auth-token": authInfo.token },
      })
      .then((res) => {
        sale_invoice_set(res.data.message);
      });
  };

  let getEmployees = async () => {
    await axios
      .post(
        `${API_URL}/api/get-employees`,
        { "select-type": "active" },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        employeesSet(res.data.message);
      });
  };

  let getCustomers = async (type = "retail") => {
    await axios
      .post(
        `${API_URL}/api/get-customers`,
        { "select-type": "active", "customer-type": type },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        res.data.message.unshift({
          customer_id: 0,
          customer_name: "General customer",
          display_text: "General customer",
          customer_mobile_no: "",
          customer_address: "",
          customer_type: "general",
        });
        customersSet(res.data.message);
      });
  };

  let getContactPersons = async (id) => {
    try {
      const response = await axios.post(
        `${API_URL}/api/get-contact-persons`,
        { customer_id: id },
        {
          headers: { "auth-token": authInfo.token },
        }
      );
      contactPersonsSet(response.data.message);
    } catch (error) {
      console.error("Error fetching contact persons:", error);
    }
  };

  let getProducts = async () => {
    await axios
      .post(
        `${API_URL}/api/get-individual-products`,
        {
          "select-type": "active",
          prodId: selectedProduct != null ? selectedProduct.prod_id : null,
        },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        productsSet(res.data.message);
        allProductsSet(res.data.message); // Store all products for image grid
        localStorage.setItem("products", JSON.stringify(res.data.message));
      });
  };

  let productToCart = () => {
    if (selectedProduct == null) {
      swal({ title: "Select Product", icon: "warning" });
      return false;
    }
    if (
      parseFloat(product_qty) > parseFloat(product_stock_qty) ||
      parseFloat(product_stock_qty) <= 0
    ) {
      swal({ title: "Stock Unavailable", icon: "warning" });
      return false;
    }

    const storageProduct = {
      prod_id: selectedProduct?.prod_id,
      prod_qty: product_qty,
      prod_floor_id: selectedFloor?.prod_floor_id,
      prod_rack_id: selectedRack?.prod_rack_id,
    };

    storageCartSet((prevStorageCart) => [...prevStorageCart, storageProduct]);

    cartSet([
      ...cart,
      {
        prod_id: selectedProduct.prod_id,
        prod_name: selectedProduct.prod_name,
        prod_sale_rate: product_rate,
        prod_brand: product_brand,
        prod_color: product_color,
        prod_qty: product_qty,
        prod_purchase_rate: product_purchase_rate,
        prod_total: product_total,
      },
    ]);

    product_rate_set(0);
    product_brand_set("");
    product_color_set("");
    product_qty_set("");
    product_total_set(0);
    selectedFloorSet(null);
    selectedRackSet(null);
    selectedProductSet(null);
    selectedQuantitySet(null);
    setResetKey(prev => prev + 1);

    productRef.current.focus();
  };

  // Function to add product to cart from image click
  const addProductFromImage = (product) => {
    selectedProductSet(product);
    product_rate_set(product.prod_rate);
    product_brand_set(product.prod_brand_name);
    product_color_set(product.prod_color_name);
    product_purchase_rate_set(
      product?.prod_purchase_rate ?? product?.prod_avarage_rate ?? 0
    );
    selectedIdSet(product.prod_id);

    // Set default quantity to 1
    product_qty_set(1);
    product_total_set(product.prod_rate * 1);

    // Focus on quantity field for quick adjustment
    setTimeout(() => {
      qtyRef.current.focus();
    }, 100);
  };

  let cartFromRemove = (index) => {
    let hardCopy = [...cart];
    hardCopy.splice(index, 1);
    cartSet(hardCopy);

    let storageCopy = [...storageCart];
    storageCopy.splice(index, 1);
    storageCartSet(storageCopy);
  };

  const [purchaseRateShow, purchaseRateShowSet] = useState(true);

  let purchaseRateShowAction = () => {
    if (purchaseRateShow == true) {
      purchaseRateShowSet(false);
    } else {
      purchaseRateShowSet(true);
    }
  };

  let saleSaveAction = async () => {
    if (savingRef.current || saveAction) return false;
    savingRef.current = true;

    if (selectedCustomer == null) {
      savingRef.current = false;
      swal({ title: "Customer is required.", icon: "warning" });
      return false;
    }
    if (cart.length == 0) {
      savingRef.current = false;
      swal({ title: "Cart is Empty.", icon: "warning" });
      return false;
    }

    if (paid > 0 && selectedCustomerPayMethod == null) {
      savingRef.current = false;
      swal({
        title: "Select Payment Receive Method",
        icon: "warning",
      });
      return false;
    }

    if (
      paid > 0 &&
      selectedCustomerPayMethod != null &&
      selectedCustomerPayMethod.pay_method_id == "bank" &&
      selectedCustomerPayAcc == null
    ) {
      savingRef.current = false;
      swal({
        title: "Select Payment Receive Account",
        icon: "warning",
      });
      return false;
    }

    let sale = {
      sale_invoice,
      sale_po_id: po_id,
      sale_emp_id: selectedEmployee != null ? selectedEmployee.employee_id : 0,
      created_isodt: selectedDate,
      customer_id: selectedCustomer.customer_id,
      contact_person_id: selectedContactPerson?.contact_person_id,
      customer_name: customer_name,
      customer_mobile_no: customer_mobile_no,
      customer_address: customer_address,
      sale_transport_cost: transport_cost,
      sub_total,
      previous_due,
      vat,
      vat_percent,
      ait,
      ait_percent,
      discount,
      discount_percent,
      total_amount,
      paid,
      due,
      sale_id: saleId,
      sale_cus_type:
        selectedCustomer.customer_type == undefined
          ? "general"
          : selectedCustomer.customer_type,
      sale_pay_method:
        selectedCustomerPayMethod != null
          ? selectedCustomerPayMethod.pay_method_id
          : "cash",
      sale_bank_id:
        selectedCustomerPayMethod == null ||
          selectedCustomerPayMethod.pay_method_id == "cash"
          ? 0
          : selectedCustomerPayAcc.bank_acc_id,
      note,
    };

    saveActionSet(true);
    let url = `/api/save-sale`;
    if (saleAction == "update") {
      url = `/api/update-sale`;
    }

    await axios
      .post(
        `${API_URL}${url}`,
        { cart, sale },
        { headers: { "auth-token": authInfo.token } }
      )
      .then((res) => {
        if (!res.data.error) {
          swal({
            title: `${res.data.message.msg} successfully. Do you want to view invoice?`,
            icon: "success",
            buttons: true,
          }).then((confirm) => {
            if (confirm) {
              // if (storageCart.length > 0) {
              //   axios.post(
              //     `${API_URL}/api/save-storage-sale`,
              //     { storageCart },
              //     { headers: { "auth-token": authInfo.token } }
              //   );
              // }
              // Clear localStorage on successful sale
              localStorage.removeItem('salesCart');
              localStorage.removeItem('salesStorageCart');

              history.push(`/sales/sales-invoice/${res.data.message.saleId}`);
              saveActionSet(false);
              savingRef.current = false;
            } else {
              savingRef.current = false;
              window.location.reload();
            }
          });
        } else {
          saveActionSet(false);
          savingRef.current = false;
          swal({
            title: `${res.data.message}`,
            icon: "error",
            buttons: true,
          });
        }
      })
      .catch((error) => {
        saveActionSet(false);
        savingRef.current = false;
        swal({
          title: error?.response?.data?.message || error?.message || "Sale save failed",
          icon: "error",
          buttons: true,
        });
      });
  };

  useEffect(() => {
    if (selectedProduct) {
      selectedFloorSet(null);
      selectedRackSet(null);
      selectedQuantitySet(null);
      fetchFloors();
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedCustomer) {
      getContactPersons(selectedCustomer.customer_id);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    if (product_brand) {
      fetchFloors();
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (product_brand && selectedFloor) {
      fetchRacks();
    }
  }, [selectedProduct, selectedFloor]);

  useEffect(() => {
    if (product_brand && selectedFloor && selectedRack && selectedProduct) {
      fetchProductQuantity();
    }
  }, [selectedProduct, selectedFloor, selectedRack]);

  const handleBarcodeScan = async (barcodeValue) => {
    const prodId = parseInt(barcodeValue.trim());
    setResetKey(prev => prev + 1);

    if (!isNaN(prodId)) {
      selectedProductSet(null);
      product_rate_set(0);
      product_brand_set("");
      product_color_set("");
      product_qty_set("");
      product_total_set(0);
      selectedFloorSet(null);
      selectedRackSet(null);
      selectedQuantitySet(null);

      try {
        const response = await axios.post(
          `${API_URL}/api/get-individual-products`,
          { productId: prodId },
          { headers: { "auth-token": authInfo.token } }
        );

        const scannedProduct = response.data.message?.[0];

        if (scannedProduct) {
          selectedProductSet(scannedProduct);
          product_rate_set(scannedProduct.prod_rate);
          product_brand_set(scannedProduct.prod_brand_name);
          product_color_set(scannedProduct.prod_color_name);
          product_purchase_rate_set(
            scannedProduct?.prod_purchase_rate ?? scannedProduct?.prod_avarage_rate ?? 0
          );
          selectedIdSet(scannedProduct.prod_id);
          qtyRef.current.focus();
        } else {
          //alert("Product not found for scanned barcode.");
        }
      } catch (err) {
        console.error("Barcode scan failed:", err);
        // alert("Failed to load product from barcode.");
      }
    } else {
      // alert('Invalid barcode!');
    }
  };

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = allProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className={classes.root}>
      <Paper
        className={classes.paper}
        style={{ marginTop: "-25px", marginBottom: "5px" }}
      >
        <h4
          style={{
            textAlign: "left",
            margin: 0,
            padding: 0,
            marginTop: "-10px",
            marginBottom: "2px",
          }}
        >
          Sales Entry
        </h4>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={2}>
            <TextField
              label="invoice no"
              variant="outlined"
              value={sale_invoice}
              disabled
              className={classes.fullWidth}
              onChange={(e) => sale_invoice_set(e.target.value)}
              name="sale_invoice"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              label="p.o"
              variant="outlined"
              value={po_id}
              className={classes.fullWidth}
              onChange={(e) => po_id_set(e.target.value)}
              name="sale_invoice"
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              size="small"
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  dateRef.current.focus();
                }
              }}
              value={selectedEmployee}
              openOnFocus={true}
              autoHighlight={true}
              style={{ width: "100%", height: "20px" }}
              loading={true}
              options={employees}
              onChange={(e, employee) => {
                selectedEmployeeSet(employee);
              }}
              getOptionLabel={(option) => option.employee_name}
              renderInput={(params) => (
                <TextField {...params} label="Sales by" variant="outlined" />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={2}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                style={{ width: "100%", marginTop: "" }}
                value={selectedDate}
                inputRef={dateRef}
                onKeyDown={(e) => {
                  if (e.key == "Enter") {
                    customerRef.current.focus();
                  }
                }}
                onChange={handleDateChangeSet}
                name="sale_date"
                label="Sales Date"
                format="yyyy/MM/dd"
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={8}>
          <Paper className={classes.paper}>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginTop: "-10px",
                marginBottom: "0px",
              }}
            >
              Customer & Product Information
            </h4>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={5} className={classes.plusLinkDiv}>
                <Grid item xs={12} sm={5}>
                  <FormControl component="fieldset">
                    <RadioGroup
                      row
                      aria-label="customer_type"
                      name="position"
                      style={{ display: "flex", flexWrap: "initial" }}
                      defaultValue={customer_type}
                      onChange={(e) => {
                        customer_type_set(e.target.value);
                      }}
                    >
                      <FormControlLabel
                        value="retail"
                        control={<Radio color="primary" />}
                        label="Retail "
                      />
                      <FormControlLabel
                        value="wholesale"
                        control={<Radio color="primary" />}
                        label="WholeSale "
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>

                <Link className={classes.plusLink} to="/sales/customers-manage">
                  +
                </Link>
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  openOnFocus={true}
                  style={{ width: "100%" }}
                  options={customers}
                  value={selectedCustomer}
                  loading={true}
                  onChange={async (e, customer) => {
                    selectedCustomerSet(customer);
                    if (customer == null) {
                      customer_name_set("");
                      customer_mobile_no_set("");
                      customer_address_set("");
                      general_customer_set(false);
                      return false;
                    }
                    if (customer.customer_id == 0) {
                      general_customer_set(true);
                      previous_due_set(0);
                    } else {
                      general_customer_set(false);
                      await axios
                        .post(
                          `${API_URL}/api/get-customer-due`,
                          { customerId: customer.customer_id },
                          { headers: { "auth-token": authInfo.token } }
                        )
                        .then((res) => {
                          previous_due_set(res.data[0].dueAmount);
                          customer_credit_limit_set(
                            customer.customer_credit_limit
                          );
                        });
                    }
                    customer_name_set(customer.customer_name);
                    customer_mobile_no_set(customer.customer_mobile_no);
                    customer_address_set(customer.customer_address);
                  }}
                  getOptionLabel={(option) => option.display_text}
                  renderInput={(params) => (
                    <TextField
                      inputRef={customerRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          productRef.current.focus();
                        }
                      }}
                      {...params}
                      label="Choose a customer"
                      variant="outlined"
                    />
                  )}
                />

                <TextField
                  autoComplete="off"
                  style={{ display: general_customer == true ? "" : "none" }}
                  label="customer name"
                  variant="outlined"
                  className={classes.inputField}
                  value={customer_name}
                  onChange={(e) => customer_name_set(e.target.value)}
                  name="customer_name"
                />
                <TextField
                  autoComplete="off"
                  disabled={general_customer == true ? false : true}
                  label="customer mobile"
                  variant="outlined"
                  className={classes.inputField}
                  value={customer_mobile_no}
                  onChange={(e) => customer_mobile_no_set(e.target.value)}
                  name="customer_mobile_no"
                />
                <TextField
                  autoComplete="off"
                  disabled={general_customer == true ? false : true}
                  label="customer address"
                  variant="outlined"
                  className={classes.inputField}
                  value={customer_address}
                  onChange={(e) => customer_address_set(e.target.value)}
                  name="customer_address"
                />

                <br />
                <br />
                <Autocomplete
                  autoHighlight={true}
                  size="small"
                  openOnFocus={true}
                  style={{ width: "100%" }}
                  options={contactPersons || []}
                  value={selectedContactPerson}
                  loading={false}
                  onChange={async (e, customer) => {
                    selectedContactPersonSet(customer);
                  }}
                  getOptionLabel={(option) => option.contact_person_name || ""}
                  renderInput={(params) => (
                    <TextField
                      inputRef={customerRef}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          productRef.current.focus();
                        }
                      }}
                      {...params}
                      label="Choose a Contact Person"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={5}
                className={classes.plusLinkDiv}
                style={{ marginTop: "5px" }}
              >
                {/* Stock status display moved to top */}
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                  <div>
                    <strong style={{ fontSize: "14px" }}>Stock Status: </strong>
                    <span style={{
                      color: selectedProduct != null
                        ? parseFloat(product_stock_qty) > 0
                          ? "green"
                          : "red"
                        : "green",
                      fontSize: "14px"
                    }}>
                      {selectedProduct != null
                        ? parseFloat(product_stock_qty) > 0
                          ? "Available"
                          : "Unavailable"
                        : "N/A"}
                    </span>
                  </div>
                  <div>
                    <strong style={{ fontSize: "14px" }}>Stock Qty: </strong>
                    <span style={{
                      color: selectedProduct != null
                        ? parseFloat(product_stock_qty) > 0
                          ? "green"
                          : "red"
                        : "green",
                      fontSize: "14px"
                    }}>
                      {product_stock_qty} {selectedProduct != null ? selectedProduct.prod_unit_name : ""}
                    </span>
                  </div>
                </div>

                <Link
                  className={classes.plusLink}
                  to="/administration/products-manage"
                >
                  +
                </Link>
                <Autocomplete
                  openOnFocus={true}
                  autoHighlight={true}
                  style={{ width: "100%", height: "20px" }}
                  options={products}
                  value={selectedProduct}
                  loading={true}
                  size="small"
                  getOptionLabel={(option) => `${option?.prod_code || ""} ${option?.prod_name || ""}`.trim()}
                  onChange={(e, product) => {
                    qtyRef.current.focus();
                    if (product == null) {
                      product_rate_set(0);
                      product_qty_set("");
                      product_brand_set("");
                      product_color_set("");
                      selectedProductSet(null);
                      return false;
                    }

                    product_rate_set(product.prod_rate);
                    product_brand_set(product.prod_brand_name);
                    product_color_set(product.prod_color_name);
                    product_purchase_rate_set(
                      product?.prod_purchase_rate ?? product?.prod_avarage_rate ?? 0
                    );
                    selectedIdSet(product.prod_id);
                    selectedProductSet(product);
                  }}
                  renderInput={(params) => (
                    <TextField
                      inputRef={productRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          brandRef.current.focus();
                        }
                      }}
                      {...params}
                      label="choose a product"
                      variant="outlined"
                    />
                  )}
                />

                <input
                  type="text"
                  onKeyDown={async (e) => {
                    if (e.key === 'Enter') {
                      const scannedCode = e.target.value.trim();
                      e.target.value = '';
                      if (scannedCode) {
                        await handleBarcodeScan(scannedCode);
                      }
                    }
                  }}
                  placeholder="Scan barcode..."
                  style={{
                    position: 'absolute',
                    opacity: 0,
                    pointerEvents: 'none',
                    top: '-1000px'
                  }}
                  autoFocus
                  key={`barcode-input-${resetKey}`}
                />

                <br />
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="text"
                      style={{ marginRight: "5px" }}
                      label="brand"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_brand}
                      onChange={(e) => {
                        product_brand_set(e.target.value);
                      }}
                      inputRef={brandRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          countryRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item sm={1}></Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="text"
                      label="country"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_color}
                      onChange={(e) => {
                        product_color_set(e.target.value);
                      }}
                      inputRef={countryRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          rateRef.current.click();
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <br />

                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Autocomplete
                      key={resetKey}
                      autoHighlight={true}
                      size="small"
                      openOnFocus={true}
                      style={{ width: "100%" }}
                      options={floors || []}
                      value={selectedFloor}
                      loading={false}
                      onChange={async (e, customer) => {
                        selectedFloorSet(customer);
                      }}
                      getOptionLabel={(option) => option.prod_floor_name || ""}
                      renderInput={(params) => (
                        <TextField
                          inputRef={customerRef}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              productRef.current.focus();
                            }
                          }}
                          {...params}
                          label="Choose a Floor"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                  <br />
                  <br />
                  <Grid item xs={12}>
                    <Autocomplete
                      autoHighlight={true}
                      size="small"
                      openOnFocus={true}
                      style={{ width: "100%" }}
                      options={racks || []}
                      value={selectedRack}
                      loading={false}
                      onChange={async (e, customer) => {
                        selectedRackSet(customer);
                      }}
                      getOptionLabel={(option) => option.prod_rack_name || ""}
                      renderInput={(params) => (
                        <TextField
                          inputRef={customerRef}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              productRef.current.focus();
                            }
                          }}
                          {...params}
                          label="Choose a Rack"
                          variant="outlined"
                        />
                      )}
                    />
                  </Grid>
                </Grid>

                <br />

                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="number"
                      style={{ marginRight: "5px" }}
                      label="sale rate"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_rate}
                      onChange={(e) => {
                        product_rate_set(e.target.value);
                      }}
                      inputRef={rateRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          qtyRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item sm={1}></Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      label="quantity"
                      variant="outlined"
                      className={classes.inputField}
                      value={product_qty}
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", "."].includes(e.key)) {
                          e.preventDefault();
                        }
                        if (e.key == "Enter") {
                          addToCartRef.current.click();
                        }
                      }}
                      onChange={(e) => {
                        product_qty_set(e.target.value.replace(/[^0-9]/g, ""));
                      }}
                      inputRef={qtyRef}
                    />
                  </Grid>

                  <Grid item xs={12} sm={12}>
                    <TextField
                      label="total"
                      variant="outlined"
                      value={product_total}
                      onChange={(e) => {
                        product_total_set(e.target.value);
                      }}
                      disabled={true}
                      className={classes.inputField}
                    />
                  </Grid>
                </Grid>

                <Grid container>
                  <Button
                    style={{
                      marginTop: "5px",
                      marginLeft: "auto",
                      fontSize: "14px",
                    }}
                    buttonRef={addToCartRef}
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => productToCart()}
                    className={classes.button}
                    startIcon={<SaveIcon />}
                  >
                    Add To Cart
                  </Button>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={2}>
                <div
                  className={"stock-info-purchaserate"}
                  onClick={() => {
                    purchaseRateShowAction();
                  }}
                >
                  <input
                    style={{ outline: 'none', boxShadow: 'none' }}
                    type={purchaseRateShow ? "password" : "text"}
                    value={
                      selectedProduct != null
                        ? parseFloat(
                          selectedProduct.prod_purchase_rate
                        ).toFixed(2)
                        : "Purchase Rate"
                    }
                  // disabled
                  ></input>
                </div>
                <div>
                  <h1 style={{ color: "black" }}>
                    {selectedQuantity ? selectedQuantity : ""}
                  </h1>
                </div>
              </Grid>
            </Grid>
          </Paper>

          <Grid container>
            <Grid item xs={12}>
              <Paper className={classes.paper} style={{ marginTop: "5px" }}>
                <h4
                  style={{
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    marginTop: "-10px",
                    marginBottom: "3px",
                  }}
                >
                  Sales Cart
                </h4>
                <TableContainer>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>SL</TableCell>
                        <TableCell align="left">Product</TableCell>
                        <TableCell align="center">Sale Rate</TableCell>
                        <TableCell align="center">Quantity</TableCell>
                        <TableCell align="right">Total Amount</TableCell>
                        <TableCell align="right">Remove</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {cart.map((product, sl) => (
                        <TableRow key={parseFloat(sl) + 1}>
                          <TableCell>{parseFloat(sl) + 1}</TableCell>
                          <TableCell align="left">
                            {product.prod_name}
                          </TableCell>
                          <TableCell align="center">
                            {product.prod_sale_rate}
                          </TableCell>
                          <TableCell align="center">
                            {product.prod_qty}
                          </TableCell>
                          <TableCell align="right">
                            {format(parseFloat(product.prod_total).toFixed(2))}
                          </TableCell>
                          <TableCell align="right">
                            <RemoveCircleIcon
                              style={{
                                cursor: "pointer",
                                color: "#FF0202",
                                marginLeft: "2px",
                              }}
                              onClick={() => {
                                cartFromRemove(sl);
                              }}
                            ></RemoveCircleIcon>
                          </TableCell>
                        </TableRow>
                      ))}

                      {cart.length != 0 ? (
                        <TableRow style={{ backgroundColor: "#fafafa" }}>
                          <TableCell
                            colSpan={4}
                            align="right"
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            Total Amount :
                          </TableCell>
                          <TableCell
                            align="right"
                            style={{ fontWeight: "bold", fontSize: "14px" }}
                          >
                            {" "}
                            {format(parseFloat(total_amount).toFixed(2))}
                          </TableCell>
                          <TableCell colSpan={1}></TableCell>
                        </TableRow>
                      ) : (
                        ""
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {cart.length !== 0 && (
                  <TableContainer style={{ marginTop: "10px" }}>
                    <Table className={classes.table} size="small">
                      <TableBody>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            Subtotal:
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px", minWidth: "120px" }}>
                            {format(parseFloat(sub_total || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            Discount ({discount_percent}%):
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            -{format(parseFloat(discount || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            VAT ({vat_percent}%):
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            +{format(parseFloat(vat || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            AIT ({ait_percent}%):
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            +{format(parseFloat(ait || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", border: "none", paddingRight: "20px" }}>
                            Transport Cost:
                          </TableCell>
                          <TableCell align="right" style={{ border: "none", paddingRight: "20px" }}>
                            +{format(parseFloat(transport_cost || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right" style={{ fontWeight: "bold", fontSize: "16px", borderTop: "2px solid #333", paddingRight: "20px" }}>
                            Grand Total:
                          </TableCell>
                          <TableCell align="right" style={{ fontWeight: "bold", fontSize: "16px", borderTop: "2px solid #333", paddingRight: "20px" }}>
                            {format(parseFloat(total_amount || 0).toFixed(2))}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                <TableContainer>
                  <Table
                    className={classes.table}
                    size="small"
                    aria-label="a dense table"
                  >
                    {cart.length != 0 ? (
                      <TableRow>
                        <TableCell style={{ width: "325px" }}>
                          <TextareaAutosize
                            onChange={(e) => {
                              note_set(e.target.value);
                            }}
                            name="note"
                            style={{
                              float: "left",
                              marginTop: "20px",
                              width: "325px",
                            }}
                            aria-label="Sale Note..."
                            rowsMin={3}
                            placeholder="Sales Note..."
                          />
                        </TableCell>

                        <TableCell colSpan={2}></TableCell>
                      </TableRow>
                    ) : (
                      ""
                    )}
                  </Table>
                </TableContainer>
              </Paper>
            </Grid>
          </Grid>

          {/* Standardized Amount Details */}
          <Grid container>
            <Grid item xs={12}>
              <Paper className={classes.paper} style={{ marginTop: "5px" }}>
                <h4
                  style={{
                    textAlign: "left",
                    margin: 0,
                    padding: 0,
                    marginTop: "-10px",
                    marginBottom: "3px",
                  }}
                >
                  Amount Details
                </h4>

                <Grid container style={{ paddingRight: "1px" }}>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      style={{ marginRight: "5px" }}
                      label="Subtotal"
                      size="small"
                      disabled
                      value={sub_total}
                      name="sub_total"
                      variant="outlined"
                      className={classes.inputField}
                    />
                  </Grid>
                  <Grid item xs={0} sm={1}></Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="number"
                      style={{ marginRight: "5px" }}
                      size="small"
                      value={previous_due}
                      name="previous_due"
                      label="Current due"
                      disabled
                      variant="outlined"
                      className={classes.inputField}
                    />
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      label="VAT (TK)"
                      value={vat}
                      name="vat"
                      onChange={handleVatInput}
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      inputRef={vatRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          vatPercentRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={0} sm={1}></Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="VAT (%)"
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      value={vat_percent}
                      name="vat_percent"
                      onChange={handleVatInput}
                      inputRef={vatPercentRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          aitRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      label="AIT (TK)"
                      value={ait}
                      name="ait"
                      onChange={handleAitInput}
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      inputRef={aitRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          aitPercentRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={0} sm={1}></Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="AIT (%)"
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      value={ait_percent}
                      name="ait_percent"
                      onChange={handleAitInput}
                      inputRef={aitPercentRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          discountRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container style={{ paddingRight: "1px" }}>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      style={{ marginRight: "5px" }}
                      size="small"
                      label="Discount(TK)"
                      variant="outlined"
                      className={classes.inputField}
                      value={discount}
                      name="discount"
                      onChange={handleDiscountInput}
                      inputRef={discountRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          discountPercentRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={0} sm={1}></Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="Discount (%)"
                      size="small"
                      variant="outlined"
                      className={classes.inputField}
                      value={discount_percent}
                      name="discount_percent"
                      onChange={handleDiscountInput}
                      inputRef={discountPercentRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          transportRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container style={{ paddingRight: "1px" }}>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      style={{ marginRight: "5px" }}
                      size="small"
                      label="Total"
                      disabled
                      variant="outlined"
                      className={classes.inputField}
                      value={total_amount}
                      name="total_amount"
                    />
                  </Grid>
                  <Grid item xs={0} sm={1}></Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="number"
                      style={{ marginRight: "5px" }}
                      size="small"
                      label="Transport Cost"
                      variant="outlined"
                      className={classes.inputField}
                      value={transport_cost}
                      name="transport_cost"
                      onChange={(e) => transport_cost_set(e.target.value)}
                      inputRef={transportRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          paidRef.current.focus();
                        }
                      }}
                    />
                  </Grid>
                </Grid>


                <Grid container style={{ paddingRight: "1px" }}>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      type="number"
                      label="Paid"
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      value={paid}
                      name="paid"
                      onChange={(e) => {
                        selectedCustomerPayMethodSet(null);
                        paid_set(e.target.value);
                      }}
                      inputRef={paidRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          dueRef.current.focus();
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={0} sm={1}></Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      type="number"
                      label="Due"
                      variant="outlined"
                      size="small"
                      className={classes.inputField}
                      disabled
                      value={due}
                      name="due"
                      onChange={(e) => due_set(e.target.value)}
                      inputRef={dueRef}
                      onKeyDown={(e) => {
                        if (e.key == "Enter") {
                          saleRef.current.click();
                        }
                      }}
                    />
                  </Grid>
                  {paid > 0 ? (
                    <Grid
                      item
                      xs={12}
                      sm={5}
                      className={classes.plusLinkDiv}
                      style={{ marginTop: "15px", marginBottom: "10px" }}
                    >
                      <Autocomplete
                        style={{ width: "100%" }}
                        options={customerPayMethods}
                        size="small"
                        classes={{
                          option: classes.option,
                        }}
                        autoHighlight={true}
                        openOnFocus={true}
                        getOptionLabel={(option) => option.pay_method}
                        value={selectedCustomerPayMethod}
                        onChange={(event, selectedObj) => {
                          selectedCustomerPayMethodSet(selectedObj);
                          if (
                            selectedObj != null &&
                            selectedObj.pay_method_id == "cash"
                          ) {
                            selectedCustomerPayAccSet(null);
                          }
                        }}
                        loading={customerPayMethods.length == 0 ? true : false}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Payment Method"
                            variant="outlined"
                            inputProps={{
                              ...params.inputProps,
                              endAdornment: (
                                <React.Fragment>
                                  {params.InputProps.endAdornment}
                                </React.Fragment>
                              ),
                            }}
                          />
                        )}
                      />
                    </Grid>
                  ) : (
                    ""
                  )}

                  <Grid item xs={12} sm={1}></Grid>

                  {paid > 0 ? (
                    selectedCustomerPayMethod != null &&
                      selectedCustomerPayMethod.pay_method == "bank" ? (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        className={classes.plusLinkDiv}
                        style={{
                          display:
                            selectedCustomerPayMethod != null &&
                              selectedCustomerPayMethod.pay_method_id == "bank"
                              ? "block"
                              : "none",
                          marginTop: "15px",
                          marginBottom: "10px",
                        }}
                      >
                        <Autocomplete
                          style={{ width: "100%" }}
                          options={customerPayAccs}
                          size="small"
                          classes={{
                            option: classes.option,
                          }}
                          autoHighlight={true}
                          openOnFocus={true}
                          getOptionLabel={(option) => option.bank_display_name}
                          value={selectedCustomerPayAcc}
                          onChange={(event, selectedObj) => {
                            selectedCustomerPayAccSet(selectedObj);
                          }}
                          loading={customerPayAccs.length == 0 ? true : false}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Bank account"
                              variant="outlined"
                              inputProps={{
                                ...params.inputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Grid>

                <Grid container style={{ paddingRight: "1px" }}>
                  <Grid item xs={12} sm={6}>
                    <LoadingButton
                      style={{ marginTop: "5px", fontSize: "18px", float: "left" }}
                      variant="contained"
                      color="primary"
                      size="small"
                      loading={saveAction}
                      disabled={saveAction}
                      buttonRef={saleRef}
                      onClick={() => {
                        saleSaveAction();
                      }}
                      className={classes.button}
                      startIcon={<SaveIcon />}
                    >
                      Sale
                    </LoadingButton>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Button
                      style={{ marginTop: "5px", fontSize: "10px", float: "right" }}
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => {
                        localStorage.removeItem('salesCart');
                        localStorage.removeItem('salesStorageCart');
                        window.location.reload();
                      }}
                      className={classes.button}
                      startIcon={<SaveIcon />}
                    >
                      New Sale
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={4}>
          <Paper className={classes.paper}>
            <h4
              style={{
                textAlign: "left",
                margin: 0,
                padding: 0,
                marginTop: "-10px",
                marginBottom: "3px",
              }}
            >
              Products Gallery
            </h4>

            {/* Product Images Grid */}
            <Grid container spacing={1} style={{ marginTop: "10px" }}>
              {currentProducts.map((product, index) => (
                <Grid item xs={2.4} key={index} style={{ padding: "1px" }}>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      borderRadius: "3px",
                      padding: "2px",
                      cursor: "pointer",
                      textAlign: "center",
                      backgroundColor:
                        selectedProduct?.prod_id === product.prod_id ? "#e3f2fd" : "#fff",
                      height: "95px",
                      width: "60px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      overflow: "hidden",
                    }}
                    onClick={() => addProductFromImage(product)}
                  >
                    {/* Image Wrapper */}
                    <div
                      style={{
                        height: "70px",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                        flexShrink: 0,
                      }}
                    >
                      {product.prod_image ? (
                        <img
                          src={`${API_URL}/products/${product.prod_image}`}
                          alt={product.prod_cat_name}
                          style={{
                            height: "100%",
                            width: "auto",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <div style={{ color: "#999", fontSize: "10px" }}>No Image</div>
                      )}
                    </div>

                    {/* Category Name */}
                    <div
                      style={{
                        fontSize: "8px",
                        marginTop: "2px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                      }}
                      title={product.prod_cat_name}
                    >
                      {product.prod_cat_name}
                    </div>
                  </div>
                </Grid>
              ))}
            </Grid>

            {/* Pagination */}
            <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
              <Pagination
                count={Math.ceil(allProducts.length / productsPerPage)}
                page={currentPage}
                onChange={(event, page) => paginate(page)}
                color="primary"
                size="small"
              />
            </div>
          </Paper>

        </Grid>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  inputField: {
    width: "100%",
    marginTop: "5px",
  },
  plusLinkDiv: {
    position: "relative",
  },
  plusLink: {
    margin: 0,
    padding: 0,
    marginTop: "-21px",
    fontSize: "29px",
    height: "21px",
    textAlign: "right",
    position: "absolute",
    right: 0,
    color: "#3e8d54",
  },
  paper: {
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  productImage: {
    width: "100%",
    height: "80px",
    objectFit: "cover",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.8,
    },
  },
}));

const mapStateToPops = (state) => {
  return {
    currentRoute: state.currentRouteReducer,
    authInfo: state.authInfoReducer,
  };
};
export default connect(mapStateToPops, { currentRouteSet })(SalesEntry);
